import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'
import { getRespondent, getGMA, getPersonality } from 'ducks/respondent'
import Link from 'redux-first-router-link'
import cx from 'classnames'

import {
  toTerms,
  toGmaQuiz,
  toGmaQuizWelcome,
  toPersonalityQuiz,
} from 'ducks/router'
import Mail from 'assets/icons/mail.svg'
import styles from './Quiz.module.scss'

import warningImg from 'assets/icons/warning.png'

import { Card } from '../Card/Card'
import { WaveContainer } from '../WaveContainer/WaveContainer'

import DotsSvg from 'assets/icons/dots.svg'
import TargetSvg from 'assets/icons/target.svg'

const getCancelButtonLabel = status => {
  return {
    completed: t`Test results`,
    created: t`Go to test`,
    started: t`Continue test`,
  }[status]
}

const GMACard = connect(
  getGMA,
  { toGmaQuiz, toGmaQuizWelcome },
)(({ uuid, status, toGmaQuiz, toGmaQuizWelcome }) => {
  return (
    <Card
      image={TargetSvg}
      name={t`Ability Test`}
      description={t`An inductive reasoning test measures your ability to identify patterns and draw logical conclusions.​`}
      buttonLabel={getCancelButtonLabel(status)}
      completed={status === 'completed'}
      onClick={() =>
        status === 'created' ? toGmaQuizWelcome({ uuid }) : toGmaQuiz({ uuid })
      }
    />
  )
})

export const MailHint = () => {
  return (
    <div className={styles.hint}>
      <img src={Mail} />
      <span>
        {t`If you have any questions do not hesitate to contact us at`}{' '}
        <a className={styles.link} href="mailto:ebber@ebber.com" key="email">
          ebber@ebber.com
        </a>
      </span>
    </div>
  )
}

const TermsHint = ({ uuid }) => {
  return (
    <div className={styles.hint}>
      <span>
        {t`By commencing the tests, you accept the`}{' '}
        <Link
          className={styles.link}
          to={toTerms({ uuid })}
        >{t`terms of use and privacy`}</Link>
      </span>
    </div>
  )
}

const PersonalityCard = connect(
  getPersonality,
  {
    toPersonalityQuiz,
  },
)(({ uuid, toPersonalityQuiz, status }) => {
  return (
    <Card
      image={DotsSvg}
      name={t`Personality Test`}
      description={t`A personality test reveals your strengths and work style to enhance self-awareness.`}
      buttonLabel={getCancelButtonLabel(status)}
      completed={status === 'completed'}
      onClick={() => toPersonalityQuiz({ uuid })}
    />
  )
})

const Quiz = connect(state => ({
  status: state.respondent.status,
}))(({ name, id: uuid, status }) => {
  const applicationFinished = status === 'completed'

  return (
    <WaveContainer>
      <div className={styles.centerContent}>
        {uuid ? (
          <>
            <div className={styles.title}>
              {applicationFinished ? (
                <span>{t`Congratulations`}!</span>
              ) : (
                <>
                  <span>{`${t`Welcome`}, `}</span>
                  <span className={styles.name}>{name}</span>
                </>
              )}
            </div>
            <div
              className={cx(styles.subtitle, {
                [styles.finished]: applicationFinished,
              })}
            >
              {applicationFinished
                ? t`You have completed both tests​. The recruitment manager will contact you to inform you about the next steps​.`
                : t`You need to take both tests to complete the test process.`}
            </div>
            <div className={styles.cards}>
              <GMACard uuid={uuid} />
              <PersonalityCard uuid={uuid} />
            </div>
          </>
        ) : (
          <div className={styles.invalidLinkBox}>
            <span className={styles.invalidLinkIcon} aria-hidden>
              <img alt="warning" src={warningImg} />
            </span>
            <span className={styles.invalidLinkText}>
              {t`This test link appears to be incorrect. Please use the link from your invitation email or contact support at`}{' '}
              <a
                className={styles.invalidLinkEmail}
                href="mailto:ebber@ebber.com"
              >
                ebber@ebber.com
              </a>
              .
            </span>
          </div>
        )}
      </div>

      <div className={styles.hints}>
        {uuid ? <TermsHint uuid={uuid} /> : null}
        <MailHint />
      </div>
    </WaveContainer>
  )
})

export default connect(getRespondent)(Quiz)
